import { HttpClient, HttpBackend } from '@angular/common/http';
import { AfterViewInit, Component, ComponentFactoryResolver, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { Utenteservice } from '../../../services/utente.service';

@Component({
  selector: 'app-extendfilter',
  templateUrl: './extendfilter.component.html',
  styleUrls: ['./extendfilter.component.css']
})
export class ExtendfilterComponent implements OnInit,AfterViewInit {

  @Input() itemData: any
  @Input() ChiudiDopoModifica:boolean=true;
  myfilterDett
  insertRecord:boolean=false;
  buttonCustomFiltro: any[] = [];
  datiJson

  constructor(
    private httpClient: HttpClient,
    private _overlaySideFormService: OverlaySideFormService,   
    private _componentFactoryResolver: ComponentFactoryResolver,
    private spinner: NgxSpinnerService,
    private userComponentService: ComponentService,
    private appService: Apiservice,
    private activatedroute: ActivatedRoute,
    private httpBackend: HttpBackend, 
    private utenteSerivce: Utenteservice,

  ) {
    
   }
  ngAfterViewInit(): void {
    console.log(this.myfilterDett);
  }

  ngOnInit() {
    this.buttonCustomFiltro = [
      {
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Conferma',
        icon: "glyphicon fa fa-bolt",
        event: 'settaFiltriConfirm'
      },      
      {
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Chiudi',
        icon: "glyphicon icon-annulla-form",
        event: 'settaFiltriChiudi'
      },
    ]


    this.myfilterDett=""
      if (this.itemData) {
        console.log("Eccco i dati in input ",this.itemData)
      }
  }
  emettiChiusuraCaption(){
    this._overlaySideFormService.close();  
  }
  formButtonsEvent(ev){

  }
  formItemsEvent(ev){

  }
  renderFormStitistiche(ev){
    
  }
}
